<template>
  <pt-customer-of-system class="pt-customer-of-system__withData"  @deleteCustomer="deleteCustomer" ref="table" :rolesList="rolesList"></pt-customer-of-system>
</template>

<script>
import PtCustomerOfSystem from './index'
export default {
  name: 'pt-customer-of-system__withData',
  components: {
    'pt-customer-of-system': PtCustomerOfSystem
  },
  data () {
    return {
      rolesList: []
    }
  },
  methods: {
    deleteCustomer (userLogin) {
      let data = {
        userLogin: userLogin
      }
      this.$store.dispatch('deleteOrganizationUser', data).then(res => {
        this.$message.success('删除系统用户成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除系统用户失败')
      })
    },
    getRolesList () {
      let data = {}
      this.$store.dispatch('rolesList', data).then(res => {
        this.rolesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取角色列表失败')
      })
    }
  },
  created () {
    this.getRolesList()
  }
}
</script>
